// extracted by mini-css-extract-plugin
module.exports = {"fwdBack":"PaginationControl_fwdBack__2G2u1","perPage":"PaginationControl_perPage__2mqN6"};